:host,
#body,
#content {
  display: flex;
  flex-direction: column;
}

@media (min-width: 480px) {
  #body {
    flex-direction: row;
    flex-wrap: wrap;
  }

  #content,
  #side-start,
  #side-end {
    flex-basis: 100%;
  }

  #side-start.half,
  #side-end.half {
    flex-basis: 50%;
  }
}

@media (min-width: 768px) {
  #body {
    min-height: 0;
    flex-wrap: nowrap;
  }

  #body,
  #content,
  #main {
    flex: 1;
  }

  #main,
  #side-start,
  #side-end {
    overflow: auto;
  }

  #side-start,
  #side-start.half {
    flex-basis: var(--holy-grail-side-start-width, 25%);
  }

  #side-end,
  #side-end.half {
    flex-basis: var(--holy-grail-side-end-width, 25%);
  }

  #side-start {
    order: -1;
  }
}

.hidden {
  display: none;
}
